<template>
  <div class="confirm">
    <div class="confirm_nav">
      <navbar
        title="确认订单"
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontweight="700"
        :fontsize="'1.8rem'"
        @goback="goBack(false)"
      />
    </div>
    <van-row class="box">
      <van-col
        span="24"
        class="no_address"
        @click="selectAddress"
        v-if="!selectedAddress.id"
      >
        <img
          class="address"
          src="../../../assets/accountAgent/common/address.png"
          alt=""
        />
        请选择收货地址
        <img
          class="more"
          src="../../../assets/accountAgent/common/more.png"
          alt=""
        />
      </van-col>
      <van-col span="24" class="show_address" v-if="selectedAddress.id">
        <span class="address">
          <img src="../../../assets/accountAgent/common/address.png" alt="" />
        </span>
        <p class="name">
          {{ selectedAddress.realname }}
          <span>{{ selectedAddress.mobile }}</span>
        </p>
        <p class="site">
          {{ selectedAddress.address_name + selectedAddress.detail_address }}
        </p>
      </van-col>
      <!-- <van-col span="24" class="show_address">
        <span class="address">
          <img src="../../../assets/accountAgent/common/address.png" alt="" />
        </span>
        <p class="name">小猫咪<span>13099998866</span></p>
        <p class="site">浙江省 杭州市 江干区 财富金融中心西楼3楼</p>
      </van-col> -->
      <van-col span="24" class="phone_num">
        认领手机数量<span>x 1</span>
      </van-col>
    </van-row>
    <van-row class="confirm_footer">
      <van-col span="24">
        <span class="total">押金合计：<span>￥2000.00</span></span>
        <span class="button">
          <btn
            :btntext="'确认'"
            :btnwidth="'10.4rem'"
            :height="'3.6rem'"
            :bgcolor="'#F9591B'"
            :borderradius="'1.8rem'"
            :btncolor="'#fff'"
            :fontsize="'1.6rem'"
            :fontweight="700"
            v-if="!creading"
            @btnClick="toSubmit"
          />
          <btn
            :btntext="'校验中...'"
            :btnwidth="'10.4rem'"
            :height="'3.6rem'"
            :bgcolor="'#F9591B'"
            :borderradius="'1.8rem'"
            :btncolor="'#fff'"
            :fontsize="'1.6rem'"
            :fontweight="700"
            loading
            v-if="creading"
          />
        </span>
      </van-col>
    </van-row>
  </div>
</template>
<script>
import navbar from "../components/nav-bar.vue";
import btn from "../components/button.vue";
import dsbridge from "dsbridge";
export default {
  components: {
    navbar,
    btn,
  },
  data() {
    return {
      lefticon: require("@/assets/accountAgent/common/back.png"),
      facility: "",
      // currentOrderSn: "",
      selectedAddress: {},
      creading: false,
    };
  },
  created() {},
  mounted() {
    window.setPay = this.setPay;
    window.selectedInfo = this.selectedInfo;
    this.deductionUA();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    selectAddress() {
      let addressID = this.selectedAddress.id || 0;
      this.params(addressID, addressID, "selectAddress");
    },
    selectedInfo(info) {
      this.selectedAddress = info;
      if (this.selectedAddress.token) {
        this.$api.setToken(this.selectedAddress.token);
      }
    },
    toSubmit() {
      if (!this.selectedAddress.id) {
        this.$toast("请选择收货地址");
        return;
      }
      this.creading = true;
      this.$api
        .post("/order/member/order/confirm", {
          order: {
            //类型：Object  必有字段  备注：主订单必传参数
            type: "surrogacy", //类型：String  必有字段  备注：订单类型
          },
          address_id: this.selectedAddress.id,
        })
        .then((confirmResult) => {
          this.$api
            .post("/order/member/order/create", {
              order: {
                //类型：Object  必有字段  备注：主订单必传参数
                type: "surrogacy", //类型：String  必有字段  备注：订单类型 线上订单：onorder, 扫码订单：scan_order,线下报单：declaration_order,机票：air,酒店：hotel,投资：investment,京东：jingdong,淘宝：taobao,油卡：oil,话费流量：rechargemobile,汽车：car，充值订单：recharge，会员升级：member_grade
                client: this.facility == "ios" ? 11 : 10, //类型：Number  必有字段  备注：客户端类型 10：安卓 11：APPIOS 12：wap 13：小程序 20：pc
                confirm: confirmResult.order.confirm, //类型：Array  必有字段  备注：订单确认信息（以下信息有确认订单接口原封不动的返回即可）
              },
              address_id: this.selectedAddress.id,
            })
            .then((createResult) => {
              // this.currentOrderSn = createResult.ordersn;
              sessionStorage.setItem("currentOrderSn", createResult.ordersn);
              let param = {
                actual_amount: createResult.actual_amount,
                order_amount: createResult.order_amount,
                ordersn: createResult.ordersn,
                order_type: "surrogacy",
              };

              if (this.facility == "ios") {
                let that = this;
                dsbridge.call("goPay", JSON.stringify(param), function (v) {
                  that.setPay(v);
                });
              } else if (this.facility == "android") {
                this.params(
                  JSON.stringify(param),
                  JSON.stringify(param),
                  "goPay"
                );
              }
            })
            .catch((err) => {
              this.creading = false;
              let keys = Object.keys(err);
              let key = keys[0];
              let message = err.message || err[key][0];
              //this.$toast(message);
              if (message.slice(0, 10) == "timeout of") {
                this.$toast("网络不给力，请稍候重试");
              } else {
                this.$toast(message);
              }
              return;
            });
        })
        .catch((err) => {
          this.creading = false;
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          //this.$toast(message);
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
          return;
        });
    },
    setPay(v) {
      let data = JSON.parse(v);
      if (data.code == 0) {
        this.$router.push({
          //支付成功
          path: "/accountAgent/result",
          query: {
            type: 1,
            ordersn: sessionStorage.getItem("currentOrderSn"),
          },
        });
      } else {
        this.$router.push({
          //支付失败
          path: "/accountAgent/detail",
          query: {
            ordersn: sessionStorage.getItem("currentOrderSn"),
            from: "pay",
          },
        });
      }
    },
    deductionUA() {
      const ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod|macintosh/i.test(ua)) {
        this.facility = "ios";
      } else if (/android/.test(ua)) {
        this.facility = "android";
      }
    },
  },
};
</script>
<style lang="less" scoped>
.confirm {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .confirm_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    background-color: #f5f6f7;
    z-index: 3;
  }

  .box {
    padding: 10rem 1.2rem 0;
    box-sizing: border-box;
    height: 100%;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    .no_address {
      height: 5.6rem;
      line-height: 5.6rem;
      padding: 0 1.2rem 0 1rem;
      background: #fff;
      border-radius: 0.5rem;
      color: #333;
      font-size: 1.6rem;
      font-weight: 700;
      margin-bottom: 1rem;

      .address {
        width: 2.6rem;
        float: left;
        margin: 1.5rem 1.5rem 0 0;
      }

      .more {
        width: 1.6rem;
        float: right;
        margin-top: 2rem;
      }
    }

    .show_address {
      min-height: 8.5rem;
      padding: 1.5rem 1rem 1.5rem 5.1rem;
      background: #fff;
      border-radius: 0.6rem;
      margin-bottom: 1rem;
      text-align: left;
      position: relative;

      .address {
        width: 5.1rem;
        padding-left: 1rem;
        min-height: 8.5rem;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        display: flex;
        align-items: center;
        box-sizing: border-box;

        img {
          width: 2.6rem;
        }
      }

      .name {
        color: #333;
        font-size: 1.6rem;
        font-weight: 700;
        height: 2.6rem;
        line-height: 2.6rem;
        margin-bottom: 0.6rem;

        span {
          margin-left: 3rem;
        }
      }

      .site {
        color: #999;
        font-size: 1.4rem;
        line-height: 2.3rem;
      }
    }

    .phone_num {
      height: 6.2rem;
      line-height: 6.2rem;
      border-radius: 0.6rem;
      background: #fff;
      padding: 0 1.5rem;
      color: #333;
      font-weight: 700;
      font-size: 1.6rem;

      span {
        color: #999;
        font-weight: 500;
        float: right;
      }
    }
  }

  .confirm_footer {
    // height: 8.3rem;
    // padding: 0.7rem 1.2rem 3.3rem;
    height: 5rem;
    padding: 0.7rem 1.2rem 0;
    background: #fff;
    color: #f9591b;
    text-align: right;
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    .total {
      line-height: 3.6rem;
      font-size: 1.4rem;
      span {
        font-size: 1.8rem;
        font-weight: 700;
        margin-right: 1.2rem;
      }
    }
    .button {
      float: right;
    }
  }
}
</style>


